import { IProgramItemGroupQuery } from '../interfaces/program-item-group.query.interface';

// @dynamic
export class ProgramItemGroup {
    id: string;
    name: string;
    sort: number;
    description: string;
    isHidden: boolean; // Frontend Field

    constructor(courseOfferingQuery: IProgramItemGroupQuery) {
        this.id = courseOfferingQuery.id.toString();
        this.name = courseOfferingQuery.name;
        this.sort = courseOfferingQuery.sort;
        this.description = courseOfferingQuery.description;
        this.isHidden = false;
    }
}
